import React from 'react'
import LoginMethodFrame from '../shared/LoginMethodFrame'
import {
  InjectedSigninMethodProps,
  withSigninMethodProps,
} from '../../context/withSigninMethodProps'

export const PureSigninUnavailable = ({
  ...props
}: InjectedSigninMethodProps) => (
  <LoginMethodFrame
    title="Unable to sign in"
    loading={false}
    recoveryPrompt="Need access?"
    recoveryText="Contact support"
    onMethodChange="mailto:support@tidyhq.com"
    {...props}
  >
    <p className="text-center mt-3">
      This account has no available sign in methods.
    </p>
  </LoginMethodFrame>
)

export const SigninUnavailable = withSigninMethodProps(PureSigninUnavailable)

export default SigninUnavailable
